// extracted by mini-css-extract-plugin
module.exports = {"container":"CookiePreferences_container__DWUZe","title":"CookiePreferences_title__QHJj7","text":"CookiePreferences_text__nE8of","subtitle":"CookiePreferences_subtitle__ULKrL"};